import React from 'react';
import PropTypes from 'prop-types';

import CART_ITEM from '../../constants/cartItems';
import { getPrintProductCartItemPrice } from '../../redux/helpers';
import CheckoutItemQuantityInput from './CheckoutItemQuantityInput';
import TrashIcon from '../../../../components/icons/TrashIcon';
import CheckoutCartItemPriceDisplay from './CheckoutCartItemPriceDisplay';
import AccountCardPreviewFile from '../../../cards/components/AccountCardPreviewFile';
import { getAsset } from '../../../../util/assets';
import CartItemVendor from './CartItemVendor';

const propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf([CART_ITEM.PRINT_PRODUCT]).isRequired,
    accountCard: PropTypes.shape({
      id: PropTypes.string.isRequired,
      print_product_configuration: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    quantity: PropTypes.number.isRequired,
  }).isRequired,
  pricing: PropTypes.shape({
    price: PropTypes.object,
    discount_price: PropTypes.object,
  }),
  loading: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

const PrintProductCartItem = ({
  item,
  loading,
  pricing,
  onRemove,
  onUpdate,
}) => {
  const { accountCard, quantity } = item;
  const price = getPrintProductCartItemPrice(item);

  return (
    <div className="checkout-cart-item checkout-print-product-cart-item">
      <div className="checkout-cart-item-content">
        <div className="checkout-cart-item-figure">
          <div className="checkout-cart-item-photo">
            <AccountCardPreviewFile
              accountCardId={accountCard.id}
              retryInterval={1000}
              fallback={
                <img src={getAsset('/simple-prints-illustration.svg')} alt="" />
              }
            />
          </div>
        </div>

        <div className="checkout-cart-item-info">
          <span className="checkout-cart-item-title">
            {accountCard.print_product_configuration.name}
          </span>

          <CheckoutCartItemPriceDisplay
            clientPrice={price}
            pricing={pricing}
            loading={loading}
          />

          <div className="checkout-cart-item-info-actions mt-2">
            <CheckoutItemQuantityInput
              onChange={value =>
                onUpdate(item.id, {
                  quantity: value,
                })
              }
              value={quantity}
            />
            <CartItemVendor cartItem={item} />
            <button
              className="checkout-cart-item-btn-remove"
              onClick={() => onRemove(item.id)}
            >
              <TrashIcon color="#fe5851" size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

PrintProductCartItem.propTypes = propTypes;

export default PrintProductCartItem;
